import { useState, useEffect } from "react"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import { toast } from 'react-hot-toast';
import { formatCurrency } from '../utils/currencyUtils';

function PositionFutures({index, tradeasset, trade}) {
  const [loading, setLoading] = useState(false);
  const [marketPrice, setMarketPrice] = useState(trade.current_price);
  const [liqPrice, setLiqPrice] = useState(trade.liq_price);
  const [pandl, setPandl] = useState(trade.pl_roi);

  useEffect(() => {
      let isCancelled = false;

      let lastRealPrice = Number(trade.current_price) || 0;
      let lastRealPnl = Number(trade.pl_roi) || 0;
      let lastRealLiqPrice = Number(trade.liq_price) || 0;

      const fetchFutures = async () => {
          try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}controller/futures.controller.php`,
                {
                    credentials: "include",
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        fetchpandl: true,
                        tradeID: trade.order_id
                    })
                }
            );

            const data = await response.json();

            if (isCancelled) return;

            if (data.status === "success" && data.trade) {
                const t = data.trade;

                const newPrice = Number(t.current_price) || 0;
                const newPnl = Number(t.pl_roi) || 0;
                const newLiqPrice = Number(t.liq_price) || 0;

                /*
                 * PRICE
                 * If server price changed, jump directly to it.
                 * If it didn't change, create a tiny realistic tick.
                 */
                if (newPrice !== lastRealPrice) {
                    lastRealPrice = newPrice;
                    setMarketPrice(newPrice);
                } else {
                    // Tiny movement when price remains unchanged
                const tick = newPrice * (Math.random() * 0.00004 - 0.00002);
                setMarketPrice(newPrice + tick);
            }

            /*
              * P&L
              * If server P&L changed, jump directly to it.
              * Otherwise make a tiny corresponding movement.
              */
            if (newPnl !== lastRealPnl) {
                lastRealPnl = newPnl;
                setPandl(newPnl);
            } else {
                const pnlTick =
                    Math.abs(newPnl || 1) *
                    (Math.random() * 0.0005 - 0.00025);

                setPandl(newPnl + pnlTick);
            }

            /*
              * Liquidation price normally shouldn't randomly move.
              * Only update it when the server changes it.
              */
            if (newLiqPrice !== lastRealLiqPrice) {
                lastRealLiqPrice = newLiqPrice;
                setLiqPrice(newLiqPrice);
            }
        }
    } catch (error) {
        // Ignore polling errors
    }
  };

  // Fetch immediately
  fetchFutures();

  // Fetch every 1 second
  const interval = setInterval(fetchFutures, 1000);

  return () => {
    isCancelled = true;
    clearInterval(interval);
  };
  }, [trade.order_id]);

  const CloseFuture = (tradeid) =>{
    setLoading(true);
    fetch(`${process.env.REACT_APP_API_URL}controller/futures.controller.php`, {
      credentials: "include",
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({ closeFuture : true, tradeid: tradeid })
    })
    .then(response => response.json())
    .then(data => {
      if (data.status === "success") {
        toast.success(data.result);
        setTimeout(() => {
          window.location.reload();
        }, 1500);
      }else{
        toast.error(data.message);
      }
      setLoading(false);
    })
    .catch(err => {
      console.error(err);
      setLoading(false);
    })
  }   

  const notional = Number(trade.amount) * Number(trade.leverage);
  const qty = trade.price ? (notional / Number(trade.price)) : 0;
  const qty1 = trade.price ? (Number(trade.amount) / Number(trade.price)) : 0;
  const pnlPct = Number(trade.amount)? (pandl / Number(trade.amount)) * 100 : 0;

  if (!tradeasset) {
    return <div style={{ textAlign: "center", marginTop: "20%", marginBottom: "20%"}}><FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '30px', color: '#ff6b35', opacity: '0.5'}} spin /></div>;
  }

  return (
    <tr key={index}>
        <td>{index + 1}</td>
        <td>#{trade.order_id}</td>
        <td>{trade.type}</td>
        <td><div className={`myBtn d-inline-block px-2 py-1 ${trade.side == "Long"?'bg-success':'bg-danger'}`} style={{fontSize:'12px'}}>{trade.side}</div></td>
        <td>{trade.future_type}</td>
        <td><span className="ms-2 px-2 py-1 rounded-pill text-prime" style={{backgroundColor: '#ff6b3520',fontSize:'12px'}}>{trade.leverage}X</span></td>
        <td className="text-nowrap">
        <img src={tradeasset.logo} alt={tradeasset.symbol} style={{width: '30px'}}/>
        <span className="fw-bold ms-1">{tradeasset.symbol}/USDT</span>
        </td>
        <td>{formatCurrency(trade.price)}</td>
        <td>{formatCurrency(trade.amount)}</td>
        <td className="text-nowrap">{qty1.toFixed(4)} {tradeasset.symbol}</td>
        <td>{formatCurrency(marketPrice)}</td>
        <td>{formatCurrency(liqPrice)}</td>
        <td className={`${pandl > 0?'text-success':'text-danger'}`}>
        <p className="mb-0 lh-1" style={{fontSize:'12px'}}>{Number(pandl).toFixed(4)} USDT</p>
        <p className="mb-0 lh-1" style={{ fontSize: '12px' }}>({pnlPct.toFixed(2)}%)</p>
        <p className="mb-0 lh-1" style={{fontSize:'12px'}}>{formatCurrency(Number(pandl))} USD</p>
        </td>
        <td>{trade.tp && trade.sl ? `${formatCurrency(trade.tp)}/${formatCurrency(trade.sl)}` : '--'}</td>
        <td className="text-nowrap">{trade.order_time}</td>
        <td>
        <div className="myBtn bg-danger fw-semibold d-inline-block px-2 py-1" style={{fontSize:'12px', cursor:'pointer'}} onClick={()=> CloseFuture(trade.order_id)}>{loading?<FontAwesomeIcon icon={faCircleNotch} style={{fontSize: '20px', color: 'white', opacity: '0.5'}} spin />:'Close'}</div>
        </td>
    </tr> 
  )
}

export default PositionFutures